import { Home, Sample, Location, FAQ, HomeTeam, Invites } from '../screens';

export const routes = [
  { path: '/',
    exact: true,
    component: Home,
  },
  { path: '/team/:team/:name',
    exact: true,
    component: HomeTeam,
  },
  { path: '/invites/:userCode',
    exact: true,
    component: Invites,
  },
  { path: '/sample',
    exact: true,
    component: Sample,
  },
  { path: '/home',
    exact: true,
    component: Home
  },
  { path: '/location/:location',
    exact: true,
    component: Location
  },
  {
    path: '/faq',
    exact: true,
    component: FAQ
  }
]



// WEBPACK FOOTER //
// ./src/config/routes.js